module.exports = __webpack_public_path__ + "img/Eye Contrast.3b1410ab.svg";